(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hwc-collection-gallery"] && !Shopify.designMode) return;
  try {
    
  function initializeHwcCollection(scope) {
    const galleries = scope.matches?.('[data-hwc-collection]') ? [scope] : scope.querySelectorAll('[data-hwc-collection]');
    galleries.forEach(gallery => {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      gallery.classList.add('hwc-enhanced');
      const modes = gallery.querySelector('.hwc-image-mode');
      if (modes) modes.hidden = false;
      gallery.querySelectorAll('[data-hwc-view]').forEach(button => button.addEventListener('click', () => {
        gallery.classList.toggle('hwc-art-only', button.dataset.hwcView === 'art');
        gallery.querySelectorAll('[data-hwc-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      const form = gallery.querySelector('#HwcCollectionFilters');
      const sort = gallery.querySelector('#HwcCollectionSort');
      if (sort && form) sort.addEventListener('change', () => form.requestSubmit());
      const min = form?.querySelector('[data-price-min]');
      const max = form?.querySelector('[data-price-max]');
      const checkPrice = () => {
        if (!min || !max) return;
        max.setCustomValidity(min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value) ? form.dataset.priceError : '');
      };
      min?.addEventListener('input', checkPrice);
      max?.addEventListener('input', checkPrice);
      form?.addEventListener('submit', () => form.querySelectorAll('input[type="number"]').forEach(input => { if (input.value === '') input.disabled = true; }));
    });
  }
  initializeHwcCollection(document);
  document.addEventListener('shopify:section:load', event => initializeHwcCollection(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hwc-home-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function(event) {
    const select = event.target.closest('[data-hwc-language-select]');
    if (!select) return;
    const form = select.form;
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search;
    form.requestSubmit();
  });
  document.addEventListener('click', function(event) {
    const link = event.target.closest('.hwc-mobile-menu a');
    if (link) link.closest('details').open = false;
  });
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const menu = document.querySelector('.hwc-mobile-menu[open]');
      if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hwc-product-main"] && !Shopify.designMode) return;
  try {
    
function initializeHwcProduct(scope) {
  const sections = scope.matches?.('[data-hwc-product]') ? [scope] : scope.querySelectorAll('[data-hwc-product]');
  sections.forEach(section => {
    if (section.dataset.initialized) return;
    const dataNode = section.querySelector('[data-hwc-product-data]');
    if (!dataNode) return;
    const data = JSON.parse(dataNode.textContent);
    section.dataset.initialized = 'true';
    const form = section.querySelector('.hwc-purchase-form');
    const selector = section.querySelector('[data-hwc-variant]');
    const quantity = form.querySelector('[name="quantity"]');
    const submit = form.querySelector('[name="add"]');
    const optionGroups = [...section.querySelectorAll('[data-option-index]')];
    const slides = [...section.querySelectorAll('[data-hwc-slide]')];
    const thumbnails = [...section.querySelectorAll('[data-hwc-thumb]')];
    const dialog = section.querySelector('dialog');
    let current = data.variants.find(variant => String(variant.id) === selector.value);
    let activeImage = Math.max(0, slides.findIndex(slide => !slide.hidden));
    const showImage = index => {
      if (!slides.length) return;
      activeImage = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== activeImage; });
      thumbnails.forEach((thumb, i) => { if (i === activeImage) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current'); });
      section.querySelector('[data-gallery-status]').textContent = data.labels.imageCount.replace('[current]', String(activeImage + 1)).replace('[total]', String(slides.length));
    };
    thumbnails.forEach((thumb, index) => thumb.addEventListener('click', event => { event.preventDefault(); showImage(index); }));
    section.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => showImage(activeImage + Number(button.dataset.galleryStep))));
    section.querySelector('.hwc-gallery-arrows')?.removeAttribute('hidden');
    section.querySelectorAll('[data-hwc-zoom]').forEach(link => link.addEventListener('click', event => {
      if (!dialog?.showModal) return;
      event.preventDefault();
      const zoomImage = dialog.querySelector('[data-hwc-zoom-image]');
      zoomImage.src = link.href;
      dialog.showModal();
    }));
    dialog?.querySelector('[data-hwc-close]').addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    const update = (changeUrl = true) => {
      const selected = optionGroups.map(group => group.querySelector('input:checked')?.value);
      current = data.variants.find(variant => variant.options.every((value, i) => value === selected[i]));
      selector.disabled = !current;
      if (current) selector.value = String(current.id);
      submit.disabled = !current?.available;
      section.querySelector('[data-hwc-add-label]').textContent = current ? (current.available ? data.labels.add : data.labels.soldOut) : data.labels.unavailable;
      section.querySelector('[data-hwc-stock]').textContent = current ? (current.available ? data.labels.available : data.labels.soldOut) : data.labels.unavailable;
      section.querySelector('[data-hwc-selected]').textContent = current ? `${data.labels.chosen}: ${current.title}` : data.labels.unavailable;
      section.querySelector('[data-hwc-price]').textContent = current?.price || '—';
      section.querySelector('[data-hwc-mobile-price]').textContent = current?.price || '—';
      const compare = section.querySelector('[data-hwc-compare]');
      compare.hidden = !current?.compare;
      compare.textContent = current?.compare || '';
      optionGroups.forEach((group, index) => group.querySelectorAll('input').forEach(input => {
        input.disabled = !data.variants.some(variant => variant.available && variant.options.every((value, i) => value === (i === index ? input.value : selected[i])));
      }));
      if (!current) return;
      quantity.min = String(current.min);
      quantity.step = String(current.step);
      if (current.max != null) quantity.max = String(current.max); else quantity.removeAttribute('max');
      let amount = Math.max(Number(quantity.value) || current.min, current.min);
      amount = current.min + Math.round((amount - current.min) / current.step) * current.step;
      if (current.max != null) amount = Math.min(amount, current.max);
      quantity.value = String(amount);
      const imageIndex = slides.findIndex(slide => slide.dataset.hwcSlide === String(current.imageId));
      if (imageIndex >= 0) showImage(imageIndex);
      if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', String(current.id)); history.replaceState({}, '', url); }
      const interest = document.querySelector('[data-hwc-project-artwork]');
      if (interest) interest.value = `${section.dataset.productTitle} — ${current.title}`;
    };
    optionGroups.forEach(group => group.addEventListener('change', () => update()));
    section.classList.add('hwc-product--enhanced');
    section.querySelector('.hwc-product-options').hidden = false;
    section.querySelectorAll('[data-quantity-step]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => { if (Number(button.dataset.quantityStep) > 0) quantity.stepUp(); else quantity.stepDown(); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    });
    section.querySelector('[data-hwc-project-link]')?.addEventListener('click', () => {
      const brief = document.querySelector('#HwcBrief');
      if (brief && !brief.value.trim() && current) brief.value = data.labels.project.replace('[artwork]', section.dataset.productTitle).replace('[option]', current.title);
    });
    form.addEventListener('submit', event => {
      if (!current?.available) { event.preventDefault(); return; }
      submit.disabled = true;
      section.querySelector('[data-hwc-add-label]').textContent = data.labels.adding;
    });
    window.addEventListener('pageshow', () => update(false));
    const mobileBar = section.querySelector('.hwc-mobile-purchase');
    if ('IntersectionObserver' in window && mobileBar) {
      const observer = new IntersectionObserver(entries => { mobileBar.hidden = entries[0].isIntersecting; }, {threshold:0});
      observer.observe(form);
    }
    update(false);
  });
}
initializeHwcProduct(document);
document.addEventListener('shopify:section:load', event => initializeHwcProduct(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hwc-product-refined"] && !Shopify.designMode) return;
  try {
    
function initializeHwpProduct(scope) {
  const sections = scope.matches?.('[data-hwp-product]') ? [scope] : scope.querySelectorAll('[data-hwp-product]');
  sections.forEach(section => {
    if (section.dataset.initialized) return;
    const dataNode = section.querySelector('[data-hwp-product-data]');
    if (!dataNode) return;
    const data = JSON.parse(dataNode.textContent);
    section.dataset.initialized = 'true';
    const form = section.querySelector('.hwp-purchase-form');
    const selector = section.querySelector('[data-hwp-variant]');
    const quantity = form.querySelector('[name="quantity"]');
    const submit = form.querySelector('[name="add"]');
    const optionGroups = [...section.querySelectorAll('[data-option-index]')];
    const slides = [...section.querySelectorAll('[data-hwp-slide]')];
    const thumbnails = [...section.querySelectorAll('[data-hwp-thumb]')];
    const dialog = section.querySelector('dialog');
    let current = data.variants.find(variant => String(variant.id) === selector.value);
    let activeImage = Math.max(0, slides.findIndex(slide => !slide.hidden));
    const showImage = index => {
      if (!slides.length) return;
      activeImage = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== activeImage; });
      thumbnails.forEach((thumb, i) => { if (i === activeImage) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current'); });
      section.querySelector('[data-gallery-status]').textContent = data.labels.imageCount.replace('[current]', String(activeImage + 1)).replace('[total]', String(slides.length));
    };
    thumbnails.forEach((thumb, index) => thumb.addEventListener('click', event => { event.preventDefault(); showImage(index); }));
    section.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => showImage(activeImage + Number(button.dataset.galleryStep))));
    section.querySelector('.hwp-gallery-arrows')?.removeAttribute('hidden');
    section.querySelectorAll('[data-hwp-zoom]').forEach(link => link.addEventListener('click', event => {
      if (!dialog?.showModal) return;
      event.preventDefault();
      const zoomImage = dialog.querySelector('[data-hwp-zoom-image]');
      zoomImage.src = link.href;
      dialog.showModal();
    }));
    dialog?.querySelector('[data-hwp-close]').addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    const update = (changeUrl = true) => {
      const selected = optionGroups.map(group => group.querySelector('input:checked')?.value);
      current = data.variants.find(variant => variant.options.every((value, i) => value === selected[i]));
      selector.disabled = !current;
      if (current) selector.value = String(current.id);
      submit.disabled = !current?.available;
      section.querySelector('[data-hwp-add-label]').textContent = current ? (current.available ? `${data.labels.add} — ${new Intl.NumberFormat(data.locale, {style:'currency',currency:data.currency}).format(current.cents * Number(quantity.value || 1) / 100)}` : data.labels.soldOut) : data.labels.unavailable;
      section.querySelector('[data-hwp-stock]').textContent = current ? (current.available ? data.labels.available : data.labels.soldOut) : data.labels.unavailable;
      section.querySelector('[data-hwp-selected]').textContent = current ? optionGroups.map(group => group.querySelector('input:checked')?.closest('label')?.querySelector('strong')?.textContent.trim()).filter(Boolean).join(' · ') : data.labels.unavailable;
      section.querySelector('[data-hwp-price]').textContent = current?.price || '—';
      section.querySelector('[data-hwp-mobile-price]').textContent = current?.price || '—';
      const compare = section.querySelector('[data-hwp-compare]');
      compare.hidden = !current?.compare;
      compare.textContent = current?.compare || '';
      optionGroups.forEach((group, index) => group.querySelectorAll('input').forEach(input => {
        input.disabled = !data.variants.some(variant => variant.available && variant.options.every((value, i) => i > index || value === (i === index ? input.value : selected[i])));
      }));
      if (!current) return;
      quantity.min = String(current.min);
      quantity.step = String(current.step);
      if (current.max != null) quantity.max = String(current.max); else quantity.removeAttribute('max');
      let amount = Math.max(Number(quantity.value) || current.min, current.min);
      amount = current.min + Math.round((amount - current.min) / current.step) * current.step;
      if (current.max != null) amount = Math.min(amount, current.max);
      quantity.value = String(amount);
      if (current.available) section.querySelector('[data-hwp-add-label]').textContent = `${data.labels.add} — ${new Intl.NumberFormat(data.locale, {style:'currency',currency:data.currency}).format(current.cents * amount / 100)}`;
      const imageIndex = slides.findIndex(slide => slide.dataset.hwpSlide === String(current.imageId));
      if (imageIndex >= 0) showImage(imageIndex);
      if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', String(current.id)); history.replaceState({}, '', url); }
      const interest = document.querySelector('[data-hwp-project-artwork]');
      if (interest) interest.value = `${section.dataset.productTitle} — ${current.title}`;
    };
    optionGroups.forEach((group, index) => group.addEventListener('change', () => {
      const selected = optionGroups.map(item => item.querySelector('input:checked')?.value);
      if (!data.variants.some(variant => variant.available && variant.options.every((value, i) => value === selected[i]))) {
        const match = data.variants.find(variant => variant.available && variant.options.every((value, i) => i > index || value === selected[i]));
        if (match) optionGroups.forEach((item, i) => item.querySelectorAll('input').forEach(input => { input.checked = input.value === match.options[i]; }));
      }
      update();
    }));
    quantity.addEventListener('change', () => update(false));
    section.classList.add('hwp-product--enhanced');
    section.querySelector('.hwp-product-options').hidden = false;
    section.querySelectorAll('[data-quantity-step]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => { if (Number(button.dataset.quantityStep) > 0) quantity.stepUp(); else quantity.stepDown(); quantity.dispatchEvent(new Event('change', {bubbles:true})); });
    });
    section.querySelector('[data-hwp-project-link]')?.addEventListener('click', () => {
      const brief = document.querySelector('#HwcBrief');
      if (brief && !brief.value.trim() && current) brief.value = data.labels.project.replace('[artwork]', section.dataset.productTitle).replace('[option]', current.title);
    });
    form.addEventListener('submit', event => {
      if (!current?.available) { event.preventDefault(); return; }
      submit.disabled = true;
      section.querySelector('[data-hwp-add-label]').textContent = data.labels.adding;
    });
    window.addEventListener('pageshow', () => update(false));
    const mobileBar = section.querySelector('.hwp-mobile-purchase');
    if ('IntersectionObserver' in window && mobileBar) {
      const observer = new IntersectionObserver(entries => { mobileBar.hidden = entries[0].isIntersecting; }, {threshold:0});
      observer.observe(form);
    }
    showImage(activeImage);
    update(false);
  });
}
initializeHwpProduct(document);
document.addEventListener('shopify:section:load', event => initializeHwpProduct(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
